import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';

const FragranceNotes = ({ sectionHeadings, fragranceNotes }) => (
  <div className="fragrance-notes">
    <div className="fragrance-notes__content grid-container full">
      <div className="grid-x">
        <div className="cell xsmall-16 large-8">
          <div className="fragrance-notes__image-box">
            <Picture
              alt={R.path(['image', 'alt'], fragranceNotes)}
              src={R.path(['image', 'imageSrc'], fragranceNotes)}
              srcset={R.path(['image', 'imageSrcset'], fragranceNotes)}
            />
          </div>
        </div>

        <div className="cell xsmall-16 large-8 flex-container align-middle align-center">
          <div className="grid-x">
            <div className="cell xsmall-16 large-10 large-offset-3">
              <div className="fragrance-notes__copy-box">
                <Heading
                  data-test="fragrance-notes-main-heading"
                  level={2}
                  extraClass="fragrance-notes__heading"
                >
                  {R.path(['fragranceNotes', 'heading'], sectionHeadings)}
                </Heading>

                {Array.isArray(R.prop('notes', fragranceNotes)) &&
                  R.prop('notes', fragranceNotes).map(
                    ({ heading, description }) => (
                      <div key={uuid()} className="fragrance-notes__item">
                        <Heading
                          data-test="fragrance-information-heading"
                          level={3}
                          extraClass="fragrance-notes__note-heading"
                        >
                          {heading}
                        </Heading>

                        <Paragraph
                          testAttribute="fragrance-notes-description"
                          extraClass="fragrance-notes__note-paragraph"
                        >
                          {description}
                        </Paragraph>
                      </div>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

FragranceNotes.propTypes = {
  fragranceNotes: PropTypes.shape({
    image: PropTypes.shape({
      imageSrc: PropTypes.string,
      imageSrcSet: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    }),
    notes: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        description: PropTypes.string,
      })
    ),
  }),
  sectionHeadings: PropTypes.shape({
    fragranceNotes: PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
    }),
  }),
};

export default FragranceNotes;
